import Vue from 'vue'
import Router from 'vue-router'
//登录路由
import Login from '@/views/login/login'
//Tab路由
import Tab from '@/views/tab/tab'
//menu路由
import Menu from "@/router/menu/menu"
// 人员
import Peronnel from "@/router/personnel/peronnel"
// 角色
import RoleManager from "@/router/roleManager/roleManager"
// 量表
import Scale from "@/router/scale/scale"
// 订单管理
import OrderManager from "@/router/orderManager/orderManager"
// 订单管理
import OpsMap from "@/router/opsMap/opsMap"
// 租户管理
import TenantManager from "@/router/tenantManager/tenantManager"

import Log from "@/router/log/log"

import Device from "@/router/device/device"

import Dict from "@/router/dict/dict";

import Factor from "@/router/factor/factor";

import Course from "@/router/course/course";
import Customer from "@/router/customer/customer";

import PsychologicalHotline from '@/router/psychologicalHotline/psychologicalHotline'
// 通知
import Notification from "@/router/notification/notification";
// 官网
import Website from "@/router/website/website";

Vue.use(Router)

export default new Router({
  mode: 'history', // 使用 history 模式
  routes: [{
    path: '/login',
    name: 'login',
    component: Login
  }, {
    path: '/tab',
    name: 'tab',
    component: Tab,
    children: [...Menu, ...Peronnel, ...RoleManager, ...Scale, ...OrderManager, ...TenantManager, ...Log, ...
      Device, ...Dict, ...Factor, ...Course, ...PsychologicalHotline, ...Notification, ...Customer, ...Website,
      { // 修改密码
        path: "/changePassword",
        name: "changePassword",
        component: resolve => require(['@/views/tab/changePassword.vue'], resolve),
        meta: {
          isLoginAuthority: true // 需要登录权限才能访问
        }
      }
    ],
    meta: {
      group: "/tab",
      isLoginAuthority: true // 需要登录权限才能访问
    }
  }, {
    path: '*',
    component: resolve => require(['@/views/notFound/notFound'], resolve),
  }, ...OpsMap]
})


// WEBPACK FOOTER //
// ./src/router/index.js